export enum FetchResponseType {
  Json = "json",
  Text = "text",
}
